import { FunctionsListItemProps } from "./components/FunctionsListItem";
export const VIDEO_ID = process.env.REACT_APP_FEATURED_VIDEO;

export const FACEBOOK_APPID = process.env.REACT_APP_FBAPP_ID;
export const FACEBOOK_PAGE_URL = process.env.REACT_APP_PAGE_URL;

export const FORMSPREE_SUBSCRIPTION_ACTION = `https://formspree.io/${process.env
  .REACT_APP_ENQUIRY_ADDRESS}`;

// Static function list data
export const FUNCTION_DATA: FunctionsListItemProps[] = [
  {
    imgSrc: require("./assets/icons-function/fuct-1.png"),
    headerText: "Đặt thiết kế trong 5 phút",
    text: "Tiết kiệm thời gian, thao tác dễ dàng",
  },
  {
    imgSrc: require("./assets/icons-function/fuct-2.png"),
    headerText: "Giao dịch trực tuyến",
    text:
      "Đặt hàng và nhận sản phẩm trực tuyến mọi lúc mọi nơi - ngay khi bạn cần",
  },
  {
    imgSrc: require("./assets/icons-function/fuct-3.png"),
    headerText: "Giao sản phẩm siêu tốc!",
    text:
      "Sẵn sàng giao sản phẩm ngay trong ngày, đáp ứng cả những trường hợp khẩn cấp nhất",
  },
  {
    imgSrc: require("./assets/icons-function/fuct-4.png"),
    headerText: "Tư vấn chuyên nghiệp",
    text:
      "Đội ngũ tư vấn dày dặn kinh nghiệm về thiết kế truyền thông thương hiệu và đa dạng mọi lĩnh vực",
  },
];



// WEBPACK FOOTER //
// ./src/routes/LandingPage/constants.ts